// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #3f51b5;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.drawer-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}
.drawer-header .header-actions {
  display: flex;
  gap: 8px;
}
.drawer-header .header-actions button {
  color: white;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}
.drawer-content.raw-json {
  padding: 16px;
}
.drawer-content.raw-json pre {
  background-color: #1e1e1e;
  color: #d4d4d4;
  padding: 16px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: "Courier New", monospace;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  border-radius: 4px;
  color: #c62828;
}
.error-message mat-icon {
  color: #f44336;
}

.summary-card,
.category-card {
  margin-bottom: 16px;
}

.summary-grid,
.category-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.summary-grid .summary-item,
.summary-grid .category-item,
.category-grid .summary-item,
.category-grid .category-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.summary-grid .summary-item.full-width,
.summary-grid .category-item.full-width,
.category-grid .summary-item.full-width,
.category-grid .category-item.full-width {
  grid-column: 1/-1;
}
.summary-grid .summary-item label,
.summary-grid .category-item label,
.category-grid .summary-item label,
.category-grid .category-item label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.summary-grid .summary-item span,
.summary-grid .summary-item p,
.summary-grid .category-item span,
.summary-grid .category-item p,
.category-grid .summary-item span,
.category-grid .summary-item p,
.category-grid .category-item span,
.category-grid .category-item p {
  font-size: 14px;
  color: #333;
}
.summary-grid .summary-item .value-message,
.summary-grid .category-item .value-message,
.category-grid .summary-item .value-message,
.category-grid .category-item .value-message {
  margin: 0;
  padding: 12px;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  border-radius: 4px;
}

.score-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 600;
}
.score-badge.score-high {
  background-color: #c8e6c9;
  color: #2e7d32;
}
.score-badge.score-medium {
  background-color: #fff9c4;
  color: #f57f17;
}
.score-badge.score-low {
  background-color: #ffcdd2;
  color: #c62828;
}

.savings {
  font-size: 18px;
  font-weight: 600;
  color: #2e7d32;
}

mat-accordion .dimension-score {
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  margin-right: 8px;
}
mat-accordion .dimension-score.score-high {
  background-color: #c8e6c9;
  color: #2e7d32;
}
mat-accordion .dimension-score.score-medium {
  background-color: #fff9c4;
  color: #f57f17;
}
mat-accordion .dimension-score.score-low {
  background-color: #ffcdd2;
  color: #c62828;
}
mat-accordion .dimension-size {
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
}
mat-accordion .dimension-size.size-small {
  background-color: #c8e6c9;
  color: #2e7d32;
}
mat-accordion .dimension-size.size-medium {
  background-color: #fff9c4;
  color: #f57f17;
}
mat-accordion .dimension-size.size-large {
  background-color: #ffcdd2;
  color: #c62828;
}
mat-accordion .dimension-size.size-unknown {
  background-color: #e0e0e0;
  color: #666;
}

.dimension-content {
  padding: 16px;
}
.dimension-content .reasoning-text {
  margin: 8px 0 0 0;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/ai-result-drawer/ai-result-drawer.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,wCAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;AAAJ;AAEI;EACE,YAAA;AAAN;;AAKA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAII;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAFN;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;AAJF;AAME;EACE,cAAA;AAJJ;;AAQA;;EAEE,mBAAA;AALF;;AAQA;;EAEE,aAAA;EACA,qCAAA;EACA,SAAA;AALF;AAOE;;;;EAEE,aAAA;EACA,sBAAA;EACA,QAAA;AAHJ;AAKI;;;;EACE,iBAAA;AAAN;AAGI;;;;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAEN;AACI;;;;;;;;EAEE,eAAA;EACA,WAAA;AAON;AAJI;;;;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;AASN;;AAJA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAOF;AALE;EACE,yBAAA;EACA,cAAA;AAOJ;AAJE;EACE,yBAAA;EACA,cAAA;AAMJ;AAHE;EACE,yBAAA;EACA,cAAA;AAKJ;;AADA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAIF;;AAAE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGJ;AADI;EACE,yBAAA;EACA,cAAA;AAGN;AAAI;EACE,yBAAA;EACA,cAAA;AAEN;AACI;EACE,yBAAA;EACA,cAAA;AACN;AAGE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EACE,yBAAA;EACA,cAAA;AADN;AAII;EACE,yBAAA;EACA,cAAA;AAFN;AAKI;EACE,yBAAA;EACA,cAAA;AAHN;AAMI;EACE,yBAAA;EACA,WAAA;AAJN;;AASA;EACE,aAAA;AANF;AAQE;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AANJ","sourcesContent":[".drawer-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f5f5;\n}\n\n.drawer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: #3f51b5;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 500;\n  }\n\n  .header-actions {\n    display: flex;\n    gap: 8px;\n\n    button {\n      color: white;\n    }\n  }\n}\n\n.drawer-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n\n  &.raw-json {\n    padding: 16px;\n\n    pre {\n      background-color: #1e1e1e;\n      color: #d4d4d4;\n      padding: 16px;\n      border-radius: 4px;\n      overflow-x: auto;\n      font-family: 'Courier New', monospace;\n      font-size: 12px;\n      line-height: 1.5;\n      margin: 0;\n    }\n  }\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  border-radius: 4px;\n  color: #c62828;\n\n  mat-icon {\n    color: #f44336;\n  }\n}\n\n.summary-card,\n.category-card {\n  margin-bottom: 16px;\n}\n\n.summary-grid,\n.category-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n\n  .summary-item,\n  .category-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    &.full-width {\n      grid-column: 1 / -1;\n    }\n\n    label {\n      font-size: 12px;\n      color: #666;\n      font-weight: 500;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    span,\n    p {\n      font-size: 14px;\n      color: #333;\n    }\n\n    .value-message {\n      margin: 0;\n      padding: 12px;\n      background-color: #e3f2fd;\n      border-left: 4px solid #2196f3;\n      border-radius: 4px;\n    }\n  }\n}\n\n.score-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-weight: 600;\n  \n  &.score-high {\n    background-color: #c8e6c9;\n    color: #2e7d32;\n  }\n\n  &.score-medium {\n    background-color: #fff9c4;\n    color: #f57f17;\n  }\n\n  &.score-low {\n    background-color: #ffcdd2;\n    color: #c62828;\n  }\n}\n\n.savings {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2e7d32;\n}\n\nmat-accordion {\n  .dimension-score {\n    padding: 2px 8px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    margin-right: 8px;\n\n    &.score-high {\n      background-color: #c8e6c9;\n      color: #2e7d32;\n    }\n\n    &.score-medium {\n      background-color: #fff9c4;\n      color: #f57f17;\n    }\n\n    &.score-low {\n      background-color: #ffcdd2;\n      color: #c62828;\n    }\n  }\n\n  .dimension-size {\n    padding: 2px 8px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 500;\n\n    &.size-small {\n      background-color: #c8e6c9;\n      color: #2e7d32;\n    }\n\n    &.size-medium {\n      background-color: #fff9c4;\n      color: #f57f17;\n    }\n\n    &.size-large {\n      background-color: #ffcdd2;\n      color: #c62828;\n    }\n\n    &.size-unknown {\n      background-color: #e0e0e0;\n      color: #666;\n    }\n  }\n}\n\n.dimension-content {\n  padding: 16px;\n\n  .reasoning-text {\n    margin: 8px 0 0 0;\n    padding: 12px;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n    line-height: 1.6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
